import { marketConstants } from '../_constants'
import { marketService } from '../_services'

export const marketActions = {
    getAllProperties
}


function getAllProperties(params) {
    return dispatch => {
        dispatch(request())

        marketService.getAllProperties(params)
            .then(
                markets => {
                    if (markets) {
                        if (markets.hasOwnProperty('data')) {
                            dispatch(success(markets.data))
                        } else {
                            dispatch(failure([{ message: markets }]))
                        }
                    }
                },
                error => {
                    console.error('error', error)
                }
            )
            .catch(error => console.error(error))
    }

    function request() { return { type: marketConstants.GETALL_REQUEST } }
    function success(markets) { return { type: marketConstants.GETALL_SUCCESS, markets } }
    function failure(error) { return { type: marketConstants.GETALL_FAILURE, error } }
}
